import { AiOutlineDownload } from "react-icons/ai";
import { VscPreview } from "react-icons/vsc";
import styles from "./Download.module.scss";
const DownloadResume = (props) => {
  return (
    <>
      {props?.resume ? (
        <div className={styles.resumePart}>
            {props.resume.name.length >= 15 ?  props.resume.name.slice(0,12)+"..." : props.resume.name}
          <a
            href={props?.resume?.url}
            download={props?.resume?.name}
            target="_blank"
          >
            <VscPreview />
          </a>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default DownloadResume;
